import { useMediaQuery } from "react-responsive";
import { useState, useEffect } from "react";
// import { getSponsor } from "../../api/api";
import "swiper/css";
import "swiper/css/pagination";
import "./sponser.css";
import Marquee from "react-fast-marquee";
import { getSponsor } from "../../redux/api/api";

const Sponsors = () => {
  const [sponsor, setSponsor] = useState([]);
  const fetchSponsor = async () => {
    try {
      const response = await getSponsor();

      setSponsor(response.data.info);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchSponsor();
  }, []);
  return (
    <Marquee className="sponser">
      {sponsor.map((item) => (
        <img className="sponserimg" src={item.image} alt="" />
      ))}
    </Marquee>

    // <div className="body__inner-wrapper">
    //   <div className="marquee">
    //     <div className="marquee__inner-wrap">
    //       <div className="marquee__inner">
    //         {sponsor.map((item) => (
    //           <div
    //             className="marquee__img"
    //             style={{
    //               backgroundImage: `url(${item.image})`,
    //             }}
    //           ></div>
    //         ))}

    //         {/* <div
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1589656966895-2f33e7653819?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span>Firefox</span>
    //         <div
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1604429868519-8a64cb3b010b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span>Horse graze</span>
    //         <div
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1534681534056-461f50de526f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span aria-hidden="true">Panda Bamboo</span>
    //         <div
    //           aria-hidden="true"
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1525382455947-f319bc05fb35?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span aria-hidden="true">Polar bear</span>
    //         <div
    //           aria-hidden="true"
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1589656966895-2f33e7653819?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span aria-hidden="true">Firefox</span>
    //         <div
    //           aria-hidden="true"
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1604429868519-8a64cb3b010b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div>
    //         <span aria-hidden="true">Horse graze</span>
    //         <div
    //           aria-hidden="true"
    //           className="marquee__img"
    //           style={{
    //             backgroundImage:
    //               "url(https://images.unsplash.com/photo-1534681534056-461f50de526f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=420&q=80)",
    //           }}
    //         ></div> */}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Sponsors;
